export enum SyncMaster {
  procurat = 'procurat',
  bp = 'bp',
  planung = 'planung',
  excel = 'excel',
}

export const createForeignRefId = (master: SyncMaster, uuid: string) => `${master}::${uuid}`;
